<div [formGroup]="form">
  <section class="address">
    <div class="flex-row-generic">
    <div class="form-group flex-item-three-columns">
      <label for="{{ baseId }}-address-one">Line 1</label>
      <input
        id="{{ baseId }}-address-one"
        type="text"
        class="form-control"
        [ngClass]="{
          error: showErrors(addressOneControl, isSubmitted),
          warning: form.warnings && !form.disabled,
          'required': isRequired(addressOneControl)
        }"
        [maxlength]="fcListValidation.validations.Address.MaxLength"
        formControlName="addressOne"
      />
      <div *ngIf="showErrors(addressOneControl, isSubmitted)" id="{{ baseId }}-warning-text-address-one" class="incorrect-input" translate>
        {{ addressOneControl.errors | fcListValidation : 'Address 1' }}
      </div>
      <div *ngIf="form.warnings && !form.disabled" id="{{ baseId }}-warning-text-address" class="warning-message" translate>
        {{ form.warnings | fcListValidation : 'Address' }}
      </div>
      <div *ngIf="form.warnings && !form.disabled" class="info-message">
        <a href="" (click)="fixAddress($event)">
          {{ addressFixMessage }}
        </a>
      </div>
    </div>
    <div class="form-group flex-item-three-columns">
      <label for="{{ baseId }}-address-two">Line 2</label>
      <input
        id="{{ baseId }}-address-two"
        type="text"
        class="form-control"
        [ngClass]="{ error: showErrors(addressTwoControl, isSubmitted), 'required': isRequired(addressTwoControl) }"
        [maxlength]="fcListValidation.validations.Address.MaxLength"
        formControlName="addressTwo"
      />
      <div *ngIf="showErrors(addressTwoControl, isSubmitted)" id="{{ baseId }}-warning-text-address-two" class="incorrect-input" translate>
        {{ addressTwoControl.errors | fcListValidation : 'Address 2' }}
      </div>
    </div>
    <div class="form-group flex-item-three-columns">
      <label for="{{ baseId }}-city">City</label>
      <input
        id="{{ baseId }}-city"
        type="text"
        class="form-control"
        [ngClass]="{ error: showErrors(cityControl, isSubmitted), 'required': isRequired(cityControl) }"
        [maxlength]="fcListValidation.validations.City.MaxLength"
        formControlName="city"
      />
      <div *ngIf="showErrors(cityControl, isSubmitted)" id="{{ baseId }}-warning-text-city" class="incorrect-input" translate>
        {{ cityControl.errors | fcListValidation : 'City' }}
      </div>
    </div>
  </div>
  <div class="flex-row-generic">
    <div class="form-group flex-item-three-columns">
      <label for="{{ baseId }}-state">State</label>
      <input
        id="{{ baseId }}-state"
        type="text"
        class="form-control"
        [ngClass]="{ error: showErrors(stateControl, isSubmitted), 'required': isRequired(stateControl) }"
        [maxlength]="fcListValidation.validations.State.MaxLength"
        formControlName="state"
      />
      <div *ngIf="showErrors(stateControl, isSubmitted)" id="{{ baseId }}-warning-text-state" class="incorrect-input" translate>
        {{ stateControl.errors | fcListValidation : 'State' }}
      </div>
    </div>
    <div class="form-group flex-item-three-columns">
      <label for="{{ baseId }}-zip">ZIP</label>
      <ap-findcontrol
        id="{{ baseId }}-zip"
        [baseId]="baseId"
        [apFormGroup]="form"
        [controlName]="'zipControl'"
        [findControlId]="FindControlIdService.ListZip"
        [(selectedPks)]="selectedPks"
        [placeHolder]=""
        (chipsChange)="onZipDataPopulate($event)"
        [disabled]="this.zipControl.disabled"
        [required]="isZipFindControlRequired"
        [formGroupSubmitted]="isSubmitted"
        [singleSelect]="true"
        [findControlMaxLength]="50"
        findControlDisplayName="Find ZIP Code"
        controlName="zip"
        (dirty)="zipControl.markAsDirty()"
        (chipValueChanged)="onZipValueChanged($event)"
      >
      </ap-findcontrol>
    </div>
    <div class="form-group flex-item-three-columns" *ngIf="isFullAddress">
      <label for="{{ baseId }}-country">Country</label>
      <input
        id="{{ baseId }}-country"
        type="text"
        class="form-control"
        [ngClass]="{ error: showErrors(countryControl, isSubmitted), 'required': isRequired(countryControl) }"
        [maxlength]="fcListValidation.validations.Country.MaxLength"
        formControlName="country"
      />
      <div *ngIf="showErrors(countryControl, isSubmitted)" id="{{ baseId }}-warning-text-country" class="incorrect-input" translate>
        {{ countryControl.errors | fcListValidation : 'Country' }}
      </div>
    </div>
  </div>
  <div class="flex-row-generic">
    <div class="form-group flex-item-three-columns" *ngIf="isFullAddress">
      <label for="{{ baseId }}-county-name">County</label>
      <input
        id="{{ baseId }}-county-name"
        type="text"
        class="form-control"
        [ngClass]="{ error: showErrors(countyNameControl, isSubmitted), 'required': isRequired(countyNameControl) }"
        [maxlength]="fcListValidation.validations.CountyName.MaxLength"
        formControlName="countyName"
      />
      <div *ngIf="showErrors(countyNameControl, isSubmitted)" id="{{ baseId }}-warning-text-county-name" class="incorrect-input" translate>
        {{ countyNameControl.errors | fcListValidation : 'County' }}
      </div>
    </div>
    <div class="form-group flex-item-three-columns" *ngIf="isFullAddress">
      <label for="{{ baseId }}-county-code">Code</label>
      <input
        id="{{ baseId }}-county-code"
        type="text"
        class="form-control"
        [ngClass]="{ error: showErrors(countyCodeControl, isSubmitted), 'required': isRequired(countyCodeControl) }"
        [maxlength]="fcListValidation.validations.CountyCode.MaxLength"
        formControlName="countyCode"
      />
      <div *ngIf="showErrors(countyCodeControl, isSubmitted)" id="{{ baseId }}-warning-text-county-code" class="incorrect-input" translate>
        {{ countyCodeControl.errors | fcListValidation : 'Code' }}
      </div>
    </div>
  </div>
    <ng-content></ng-content>
  </section>
</div>
